import type { SitesFilters } from '../types';

/**
 * Query key factory for sites feature
 * Follows TanStack Query best practices for key organization
 */
export const siteKeys = {
  all: ['sites'] as const,
  lists: () => [...siteKeys.all, 'list'] as const,
  list: (filters: SitesFilters) => [...siteKeys.lists(), filters] as const,
  details: () => [...siteKeys.all, 'detail'] as const,
  detail: (id: string) => [...siteKeys.details(), id] as const,
  detailWithOptions: (id: string) => [...siteKeys.details(), id, 'options'] as const,
  changelog: (id: string) => [...siteKeys.details(), id, 'changelog'] as const,
  options: () => [...siteKeys.all, 'options'] as const,
  accounts: () => ['accounts'] as const,
};
